var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolutionTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.6067 17.9329C35.0056 11.2646 28.5029 6.63379 20.8854 6.63379C13.2679 6.81902 6.95091 11.8203 4.53561 18.4886H3.4209L3.60665 24.416C3.79244 34.048 11.7816 41.8277 21.6286 41.6425C31.2898 41.4572 39.093 33.4923 38.9072 23.675L38.7215 17.7476L37.6067 17.9329Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.0712 36.0864C30.8191 36.0864 38.7214 28.208 38.7214 18.4895C38.7214 8.77098 30.8191 0.892578 21.0712 0.892578C11.3232 0.892578 3.4209 8.77098 3.4209 18.4895C3.4209 28.208 11.3232 36.0864 21.0712 36.0864Z",
    fill: "#EAEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.0713 33.8615C29.5879 33.8615 36.4921 26.9783 36.4921 18.4874C36.4921 9.9965 29.5879 3.11328 21.0713 3.11328C12.5546 3.11328 5.65063 9.9965 5.65063 18.4874C5.65063 26.9783 12.5546 33.8615 21.0713 33.8615Z",
    fill: "#EAEAEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M5.65061 23.676C8.31848 23.676 10.4812 21.5198 10.4812 18.86C10.4812 16.2002 8.31848 14.0439 5.65061 14.0439C2.98274 14.0439 0.819824 16.2002 0.819824 18.86C0.819824 21.5198 2.98274 23.676 5.65061 23.676Z",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M36.4921 22.9338C39.1599 22.9338 41.3226 20.7775 41.3226 18.1177C41.3226 15.4579 39.1599 13.3018 36.4921 13.3018C33.8242 13.3018 31.6615 15.4579 31.6615 18.1177C31.6615 20.7775 33.8242 22.9338 36.4921 22.9338Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionTop);
export default __webpack_public_path__ + "static/media/solution-top.38f135dd8832b31fc45c10c16be2eca8.svg";
export { ForwardRef as ReactComponent };